import { render, staticRenderFns } from "./code_owners.vue?vue&type=template&id=b3423098&vue3"
import script from "./code_owners.vue?vue&type=script&lang=js&vue3"
export * from "./code_owners.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports